// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

// import Notify from "@werner/App/Components/Notify";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import GridItem from "@insite/mobius/GridItem";
import Notify from "@werner/App/Components/Notify";
import { DLSectionTitle, SectionContainer } from "@werner/App/Widgets/DesignSystem/DesignSystem.helpers";
import React, { FC } from "react";

const NotifyTab: FC = props => {
    return (
        <SectionContainer>
            <GridItem width={12}>
                <DLSectionTitle>Notify</DLSectionTitle>
            </GridItem>
            <GridItem width={12}>
                <Notify type="success" title={translate("Success Notification")}>
                    {translate("Additional Copy Goes Here")}
                </Notify>
            </GridItem>
            <GridItem width={12}>
                <Notify type="danger" title={translate("Danger Notification")}>
                    {siteMessage("Additional Copy Goes Here")}
                </Notify>
            </GridItem>
            <GridItem width={12}>
                <Notify type="info" title={translate("Info Notification")}>
                    {siteMessage("Additional Copy Goes Here")}
                </Notify>
            </GridItem>
            <GridItem width={12}>
                <Notify type="warning" title={translate("Warning Notification")}>
                    {siteMessage("Additional Copy Goes Here")}
                </Notify>
            </GridItem>
        </SectionContainer>
    );
};

export default NotifyTab;
